import type { SupportGuideProps } from "@/types/support-guide";
import type { DefaultConfiguration, Section } from "../types";

import { Home3, MessageQuestion, Messages1 } from "iconsax-react";

export const defaultPosition = "bottom-right";
export const defaultSections = [
  {
    icon: <Home3 color="#948A8A" size="20" />,
    id: "Home",
    title: "Home",
  },
  {
    icon: <MessageQuestion color="#948A8A" size="20" />,
    id: "Issue",
    title: "Report an Issue",
  },
  {
    icon: <Messages1 color="#948A8A" size="20" />,
    id: "Chat",
    title: "Live Chat",
  },
] satisfies Section[];

export const defaultSupportGuide = {
  gradient: ["#ff9e9988", "white"],
  system: "Exchange",
  titles: [
    {
      description: "getting started AFEX System",
      guideSections: [
        {
          heading: "Step 1: Download the App",
          steps: [
            "Head to your app store (Google Play Store or Apple App Store) and search for [App Name].",
            "Tap the Install button and wait for the app to download.",
          ],
        },
        {
          heading: "Step 2: Download the App",
          steps: [
            "Open the app and tap on Sign Up.",
            "Provide your details such as name, email, and a secure password.",
          ],
        },
      ],
      heading: "Getting Started with AFEX System",
      id: 1,
    },
  ],
} satisfies SupportGuideProps;

export const defaultConfiguration: DefaultConfiguration = {
  position: defaultPosition,
  sections: defaultSections,
  supportGuide: defaultSupportGuide,
  icon: <MessageQuestion color="#FFFFFF" size={20} variant="Bold" />,
};
